import { MultiSelect as MantineMultiSelect } from '@mantine/core';
import type { MultiSelectProps as MantineMultiSelectProps } from '@mantine/core';
import './MultiSelect.css';

export interface MultiSelectProps extends Omit<MantineMultiSelectProps, 'error' | 'value' | 'onChange'> {
    error?: string;
    value?: (string | number)[] | null;
    onChange?: (value: (string | number)[]) => void;
    withinPortal?: boolean;
}

export default function MultiSelect({
    error,
    className = '',
    value,
    onChange,
    ...props
}: MultiSelectProps) {
    const selectClass = `multiselect ${error ? 'multiselect--error' : ''} ${className}`.trim();

    // Преобразуем value в строки для Mantine MultiSelect
    const stringValue = value?.map(v => v.toString()) || [];

    const handleChange = (values: string[]) => {
        if (!onChange) return;

        // Всегда конвертируем обратно в числа
        const convertedValues = values.map(v => Number(v));

        onChange(convertedValues);
    };

    return (
        <div className="multiselect-wrapper">
            <MantineMultiSelect
                className={selectClass}
                value={stringValue}
                onChange={handleChange}
                error={error}
                {...props}
            />
        </div>
    );
}

